let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("acuke")).then(() => parcelRequire('4E57L'));